/** Strip trailing slash so path joins stay clean. */
const trimTrailingSlash = (url: string) => url.replace(/\/$/, '');

/** Join a base URL with a path segment (no leading slash required on path). */
export const joinUrl = (base: string, path: string) =>
  `${trimTrailingSlash(base)}/${path.replace(/^\//, '')}`;

// --- Sister sites / apps ---
export const CLEVER_CLINIC_MARKETING_URL = 'https://cleverclinic.co.uk/';
export const CLEVER_PATIENTS_MARKETING_URL = 'https://cleverpatients.co.uk/';
export const HEALTHXCHANGE_DEVICES_MARKETING_URL =
  'https://www.healthxchangedevices.com/';
export const HEALTHXCHANGE_ACADEMY_URL = 'https://healthxchangeacademy.com/';
export const HEALTHXCHANGE_SITE_URL = 'https://www.healthxchange.com/';
export const HEALTHXCHANGE_EPHARMACY_URL = 'https://shop.healthxchange.com/';
/** Production ePharmacy Devices category listing (categoryId 112). */
export const HEALTHXCHANGE_EPHARMACY_DEVICES_CATEGORY_ID = '112';
export const HEALTHXCHANGE_EPHARMACY_DEVICES_CATEGORY_URL = joinUrl(
  HEALTHXCHANGE_EPHARMACY_URL,
  `product-listing?categoryId=${HEALTHXCHANGE_EPHARMACY_DEVICES_CATEGORY_ID}`,
);
export const CLEVER_CLINIC_APP_URL = 'https://app.cleverclinic.co.uk/';
export const CLEVER_PATIENTS_APP_URL = 'https://app.cleverpatients.co.uk/';

export const HEALTHXCHANGE_ACADEMY_COURSES_URL = joinUrl(
  HEALTHXCHANGE_ACADEMY_URL,
  'courses/',
);

// --- Marketing site legal / info pages ---
export const HEALTHXCHANGE_PRIVACY_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'privacy',
);
export const HEALTHXCHANGE_TERMS_URL = joinUrl(HEALTHXCHANGE_SITE_URL, 'terms');
export const HEALTHXCHANGE_COOKIES_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'cookies',
);
export const HEALTHXCHANGE_OFFER_TERMS_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'offer-terms-conditions',
);
export const HEALTHXCHANGE_DELIVERY_INFORMATION_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'delivery-information',
);
export const HEALTHXCHANGE_TRAINING_TERMS_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'training-terms',
);
export const HEALTHXCHANGE_PATIENT_SAFETY_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'patient_safety',
);
export const HEALTHXCHANGE_CLINIC_FINDER_URL = joinUrl(
  HEALTHXCHANGE_SITE_URL,
  'clinic-finder',
);
export const HEALTHXCHANGE_LOGIN_URL = joinUrl(HEALTHXCHANGE_SITE_URL, 'login');
export const HEALTHXCHANGE_ABOUT_URL = joinUrl(HEALTHXCHANGE_SITE_URL, 'about');

// --- Brand social (group / ePharmacy) ---
export const HEALTHXCHANGE_INSTAGRAM_URL =
  'https://www.instagram.com/healthxchangeuk';
export const HEALTHXCHANGE_LINKEDIN_URL =
  'https://www.linkedin.com/company/healthxchange-pharmacy';
export const HEALTHXCHANGE_X_URL = 'https://x.com/healthxchangeuk';
export const HEALTHXCHANGE_YOUTUBE_URL =
  'https://www.youtube.com/@healthxchangeuk';
export const HEALTHXCHANGE_TIKTOK_URL = 'https://www.tiktok.com/@healthxchange';
